module.exports = __webpack_public_path__ + "img/sunrise.7e3095d9.jpg";